import {FC} from 'react';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import TextField from '@mui/material/TextField';
import DateProvider from './Provider';

export interface DateTimePickerProps {
  label?: string,
  value: Nullable<Date>,
  onChange: (date: Nullable<Date>) => void,
  disabled?: boolean,
  required?: boolean,
  placeholder?: string,
  minDate?: any,
  showError?: boolean,
  errorMessage?: string;
}

const MaterialDateTimePicker: FC<DateTimePickerProps> = ({
  onChange, value, label, required, placeholder,
  disabled, errorMessage, minDate, showError
}) => {
  return (
    <DateProvider>
      <MobileDateTimePicker
        value={value}
        label={label}
        onChange={onChange}
        renderInput={(props) =>
          <TextField
            {...props}
            placeholder={placeholder}
            size="small"
            className="date-picker"
            required={required}
            helperText={errorMessage}
            error={showError}
          />
        }
        minDate={minDate}
        disabled={disabled}
        clearable={!disabled}
      />
    </DateProvider>
  );
};

export default MaterialDateTimePicker;
